import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Field } from "formik";

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    "& .MuiInputBase-input": {
      padding: "0px 30px",
      height: "50px",
      [theme.breakpoints.down("md")]: {
        height: "45px",
      },
      [theme.breakpoints.down("sm")]: {
        height: "45px",
      },
      [theme.breakpoints.down("xs")]: {
        height: "45px",
      },
    },
  },

  title: {
    fontFamily: "Gilroy-ExtraBold, serif",
    color: "#000",
    fontSize: "50px",
    marginTop: "80px",
    marginBottom: "60px",
    [theme.breakpoints.down("md")]: {
      fontSize: "30px",
      marginBottom: "60px",
      marginTop: "100px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "30px",
      marginBottom: "30px",
      marginTop: "100px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "25px",
      marginBottom: "20px",
      marginTop: "30px",
    },
  },
  paper: {
    padding: "0",
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRadius: "30px",
  },

  field: {
    marginTop: "1.5rem",
    padding: "20px",
    border: "1px solid #e45826",
    "&:hover": {
      boxShadow: "none",
    },
  },

  button: {
    borderRadius: "50px",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    backgroundColor: "#F95919",
    color: "#fff",
    width: "180px",
    height: "50px",
    marginTop: "50px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "30px",
      marginBottom: "30px",
    },
    "&:hover": {
      backgroundColor: "#e45826",
      boxShadow: "none",
    },
  },
}));

export const CssTextField = withStyles({
  root: {
    width: "80%",

    "& label.Mui-focused": {
      color: "#e45826",
      borderRadius: "50px",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#F95919",
      borderRadius: "25px",
    },
    "& .MuiInputBase-input": {},
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #FF5903",
        boxShadow: "0 3px 6px rgb(187 131 83 / 25%)",
        borderRadius: "50px",
      },
      "&:hover fieldset": {
        borderColor: "#F95919",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#F95919",
      },
    },
  },
})(Field);
